import React, { useState } from 'react';
import Cookies from 'js-cookie';
import useLocale from '@/hooks/useLocale';
import themeV2 from '@/themes/defaultThemeV2';
import * as Styles from './NodeJsBanner.styles';
import {
  Button,
  IconButton,
  IconClose,
} from 'gatorcomponents';
import { NODEJS_DEPLOY_FORM_URL } from '@/config/urls/nodejsHostingUrls';
import nodeHostingDesktop from '@/media/nodejsHosting/node-hosting.avif';
import nodeHostingMobile from '@/media/nodejsHosting/node-hosting-mobile.avif';

const COOKIE_NAME = 'nodejs-banner-closed';

const NodeJsBanner = () => {
  const [closed, setClosed] = useState(() => Cookies.get(COOKIE_NAME) === 'true');
  const { sites: locale } = useLocale();

  if (closed) {
    return null;
  }

  const handleCtaClick = () => {
    window.open(NODEJS_DEPLOY_FORM_URL, '_blank', 'noopener,noreferrer');
  };

  const handleClose = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: 30 });
    setClosed(true);
  };

  return (
    <Styles.Wrapper data-testid="nodejs-banner">
      <Styles.LogoPlaceholder>
        <picture>
          <source
            media={`(max-width: ${themeV2.breakpoints.md})`}
            srcSet={nodeHostingMobile}
            type="image/avif"
          />
          <source srcSet={nodeHostingDesktop} type="image/avif" />
          <Styles.LogoImage
            src={nodeHostingDesktop}
            alt={locale.nodeJsBanner.logoAlt}
            loading="lazy"
          />
        </picture>
      </Styles.LogoPlaceholder>
      <Styles.Separator />
      <Styles.Content>
        <Styles.Title>
          <strong>{locale.nodeJsBanner.title}</strong>
          {locale.nodeJsBanner.titleComplement}
        </Styles.Title>
        <Styles.Description>
          {locale.nodeJsBanner.description}
        </Styles.Description>
      </Styles.Content>
      <Styles.Actions>
        <Button
          onClick={handleCtaClick}
          variant="secondary"
          data-testid="nodejs-banner-cta"
          label={locale.nodeJsBanner.cta}
        />
      </Styles.Actions>
      <Styles.CloseAdapter>
        <IconButton
          onClick={handleClose}
          variant="clear"
          data-testid="nodejs-banner-close"
        >
          <IconClose />
        </IconButton>
      </Styles.CloseAdapter>
    </Styles.Wrapper>
  );
};

export default NodeJsBanner;
